import { render, staticRenderFns } from "./language-selector-mini.vue?vue&type=template&id=944824e2&"
import script from "./language-selector-mini.vue?vue&type=script&lang=ts&"
export * from "./language-selector-mini.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('944824e2')) {
      api.createRecord('944824e2', component.options)
    } else {
      api.reload('944824e2', component.options)
    }
    module.hot.accept("./language-selector-mini.vue?vue&type=template&id=944824e2&", function () {
      api.rerender('944824e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/language-selector-mini/language-selector-mini.vue"
export default component.exports